import styled from '@emotion/styled/macro';
import vars from '@variables';
import { Link } from 'gatsby';
import { NavbarLanguageButtonAStyleProps } from './navabar-language-button.types';
import { shouldForwardProp } from '@utils/utils';

export const Wrapper = styled.div`
  position: relative;
`;

export const DropdownWrapper = styled.div`
  position: absolute;
  top: 100%;
  border: 1px solid lightGrey;
  background-color: white;
  border-radius: 0 0 4px 4px;
`;

export const StyledButton = styled('button', {
  shouldForwardProp: prop =>
    shouldForwardProp(['hideBorders', 'isExpanded', 'textColor'], prop),
})<NavbarLanguageButtonAStyleProps>(
  ({ hideBorders, textColor, isExpanded }) => {
    return `
  font-weight: ${vars.fontWeightMedium};
  background: transparent;
  border: 0;
  display: flex;
  align-items: center;
  padding-left: ${vars.spacingS};
  padding-right: 16px;
  padding-top: 1.4rem;
  padding-bottom: 1.4rem;
  border-left: ${hideBorders ? '0' : '1px solid lightGrey'};
  height: ${vars.primaryNavHeight};
  font-size: 1.6rem;
  color: ${textColor};

  &:hover {
    cursor: pointer;
  }

  ${
    isExpanded &&
    `
      &::after {
        content: '';
        border-bottom: 2px solid ${vars.coreDarkGrey};
        position:absolute;
        bottom: -1px;
        z-index: 999;
        left: 14px;
        right: 13px;
        border-radius: 2px 2px 0px 0px;
        display: block;
      }
  `
  }
  `;
  }
);

const linkStyles = `
  font-weight: ${vars.fontWeightMedium};
  display: block;
  padding: ${vars.spacingM};
  font-size: 1.4rem;
  text-decoration: none;
  
  &:hover {
    background-color: #f9fafb;
  }
`;

export const DropdownLink = styled(Link)`
  ${linkStyles}
`;

export const DropdownExternalLink = styled.a`
  ${linkStyles}
`;
